<template>
  <footer class="bg-dark-bg text-white">
    <div class="max-w-6xl mx-auto px-4 lg:px-8 py-10">
      <!-- 桌面端四列网格 -->
      <div class="hidden lg:grid grid-cols-4 gap-8">
        <div>
          <h4 class="text-lg font-bold mb-4">Berlin Shelves Service</h4>
          <ul class="space-y-2 text-sm text-gray-300">
            <li><router-link to="/budgeting" class="hover:text-white transition-colors">Budgeting</router-link></li>
            <li><router-link to="/product" class="hover:text-white transition-colors">Sales Service</router-link></li>
            <li><router-link to="/product" class="hover:text-white transition-colors">Installation</router-link></li>
            <li><router-link to="/product" class="hover:text-white transition-colors">After-sale Service</router-link></li>
          </ul>
        </div>

        <div>
          <h4 class="text-lg font-bold mb-4">About Us</h4>
          <ul class="space-y-2 text-sm text-gray-300">
            <li><router-link to="/about" class="hover:text-white transition-colors">About Us</router-link></li>
          </ul>
        </div>

        <div>
          <h4 class="text-lg font-bold mb-4">Products</h4>
          <ul class="space-y-2 text-sm text-gray-300">
            <li><router-link to="/product?category=0" class="hover:text-white transition-colors">Supermarket Gondola</router-link></li>
            <li><router-link to="/product?category=1" class="hover:text-white transition-colors">Warehouse Rack</router-link></li>
            <li><router-link to="/product?category=2" class="hover:text-white transition-colors">Glass Showcase</router-link></li>
            <li><router-link to="/product?category=3" class="hover:text-white transition-colors">Wooden Display</router-link></li>
            <li><router-link to="/product?category=4" class="hover:text-white transition-colors">Vegetable Rack</router-link></li>
            <li><router-link to="/product?category=5" class="hover:text-white transition-colors">Checkout Counter</router-link></li>
            <li><router-link to="/product?category=6" class="hover:text-white transition-colors">Shopping Cart</router-link></li>
            <li><router-link to="/product?category=7" class="hover:text-white transition-colors">Customizing Display</router-link></li>
          </ul>
        </div>

        <div>
          <h4 class="text-lg font-bold mb-4">Contact Us</h4>
          <p class="text-sm text-gray-300 mb-2">📍 广东省广州市番禺区</p>
          <p class="text-sm text-gray-300 mb-2">📞 18027254019</p>
          <p class="text-sm text-gray-300">✉ nicolasfranchet@gmail.com</p>
        </div>
      </div>

      <!-- 移动端折叠面板 -->
      <div class="lg:hidden space-y-1">
        <div v-for="section in footerSections" :key="section.title" class="border-b border-gray-600">
          <button
            class="w-full flex items-center justify-between py-4 text-left"
            @click="section.open = !section.open"
          >
            <span class="font-bold">{{ section.title }}</span>
            <svg
              class="w-5 h-5 transition-transform"
              :class="section.open ? 'rotate-180' : ''"
              fill="none" stroke="currentColor" viewBox="0 0 24 24"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
            </svg>
          </button>
          <div v-show="section.open" class="pb-4 text-sm text-gray-300 space-y-2">
            <template v-if="section.links">
              <div v-for="link in section.links" :key="link.path">
                <router-link :to="link.path" class="hover:text-white transition-colors">{{ link.label }}</router-link>
              </div>
            </template>
            <template v-if="section.content">
              <p v-for="line in section.content" :key="line" class="py-1">{{ line }}</p>
            </template>
          </div>
        </div>
      </div>
    </div>

    <!-- 版权栏 -->
    <div class="border-t border-gray-600 py-4 text-center text-sm text-gray-400">
      <p>© 2024 BERLIN SHELVES. All rights reserved.</p>
      <p class="mt-2">
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" class="hover:text-white transition-colors">粤ICP备2026161231号</a>
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "CommonFooter",
  data() {
    return {
      footerSections: [
        {
          title: 'Berlin Shelves Service',
          open: false,
          links: [
            { path: '/budgeting', label: 'Budgeting' },
            { path: '/product', label: 'Sales Service' },
            { path: '/product', label: 'Installation' },
            { path: '/product', label: 'After-sale Service' },
          ]
        },
        {
          title: 'About Us',
          open: false,
          links: [
            { path: '/about', label: 'About Us' },
          ]
        },
        {
          title: 'Products',
          open: false,
          links: [
            { path: '/product?category=0', label: 'Supermarket Gondola' },
            { path: '/product?category=1', label: 'Warehouse Rack' },
            { path: '/product?category=2', label: 'Glass Showcase' },
            { path: '/product?category=3', label: 'Wooden Display' },
            { path: '/product?category=4', label: 'Vegetable Rack' },
            { path: '/product?category=5', label: 'Checkout Counter' },
            { path: '/product?category=6', label: 'Shopping Cart' },
            { path: '/product?category=7', label: 'Customizing Display' },
          ]
        },
        {
          title: 'Contact Us',
          open: false,
          content: [
            '📍 广东省广州市番禺区',
            '📞 18027254019',
            '✉ nicolasfranchet@gmail.com',
          ]
        }
      ]
    }
  }
}
</script>
